import { useDeleteActorDocumentMutation } from "Actors/Api/Mutations/useDeleteActorDocumentMutation";
import { useUploadActorDocumentMutation } from "Actors/Api/Mutations/useUploadActorDocumentMutation";
import { useActorDocumentsQuery } from "Actors/Api/Queries/useActorDocumentsQuery";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { DocumentsSection } from "Shared/Documents/DocumentsSection";

interface ActorDocumentsSectionProps {
  actorID: string;
}

export const ActorDocumentsSection = ({
  actorID,
}: ActorDocumentsSectionProps): React.ReactNode => {
  const { t } = useResource();

  const { data, isLoading } = useActorDocumentsQuery(actorID);
  const uploadMutation = useUploadActorDocumentMutation(actorID);
  const deleteMutation = useDeleteActorDocumentMutation(actorID);

  return (
    <DocumentsSection
      title={t(Resources.Documents.SectionTitle)}
      documents={data?.items}
      isLoading={isLoading}
      onUpload={(file, displayName) =>
        uploadMutation.mutateAsync({ file, displayName })
      }
      isUploading={uploadMutation.isPending}
      onDelete={deleteMutation.mutateAsync}
    />
  );
};
